<template>
  <div
    class="wysiwyg"
    v-html="content"
  />
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.wysiwyg {
  padding: 0 $padding;
  h5 {
    font-family: 'HeyAugust';
    font-size: 2.25em;
    line-height: normal;
  }

  blockquote {
    border-left: 6px solid color(dark);
    margin: 1.5em 10px;
    padding: 0.5em 10px;
    quotes: "\201C""\201D""\2018""\2019";
    font-style: italic;
  }

  blockquote:before {
    color: #ccc;
    content: open-quote;
    font-size: 4em;
    line-height: 0.1em;
    margin-right: 0.25em;
    vertical-align: -0.4em;
  }

  blockquote p {
    display: inline;
  }

}

.image-caption + .wysiwyg {
  margin-top: rem(20);
}
</style>


<docs>
  ```vue
  <Wysiwyg content="<h1>Title</h1><p>Body text</p>" />
  ```
</docs>
